import { filter } from "rxjs/operators";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { RadarService } from "./radar-chart.service";
import * as moment from "moment";
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: "app-radar-chart",
  templateUrl: "./radar.component.html",
  styleUrls: ["./radar.component.scss"],
})
export class RadarComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private radarService: RadarService,
    public spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  @ViewChild("mdOptionsGrap") mdOptionsGrap: ModalDirective;
  objectFinal;
  @Input() listColumn = [];
  @Input() queryId: string;
  @Input() basedOnId: string;
  @Input() queryConfigType: string;
  @Input() selectTypeGraphic;
  @Input() arguments = [];
  @Output() onVewGraphic: EventEmitter<any> = new EventEmitter<any>();
  series = [];
  args = [];
  objectoFinal = [];
  objectRequest = {};
  registerRadarForm: FormGroup;
  controls: any;
  submitted = false;
  dataGraphic: any = {};
  objectGraphic: any = {};
  datoFormater: any = {};
  msgSpiner = 'Cargando...';
  positionList = [
    { name: "right", title: "Derecha" },
    { name: "left", title: "Izquierda" },
    { name: "top", title: "Arriba" },
    { name: "bottom", title: "Abajo" },
  ];
  message = {
    message: null,
    class: null,
  };
  color: String;

  estiloList = [
    { name: "Basic Radar", title: "Basic Radar" },
    { name: "Multiple Series Radar", title: "Multiple Series Radar" },
    { name: "Polygon Fill", title: "Polygon Fill" },
  ];

  newObject = {
    series: [
      {
        name: "Series 1",
        data: [80, 50, 30, 40, 84, 20],
      },
      {
        name: "Series 2",
        data: [40, 45, 50, 67, 87, 90],
      },
      {
        name: "Series 3",
        data: [40, 70, 30, 48, 90, 50],
      },
    ],
    chart: {
      background: "",
      height: 700,
      width: 700,
      with: 300,
      type: "radar",
      toolbar: {
        show: false,
        offsetX: 0,
        offsetY: 90,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    legend: {
      show: true,
      floating: false,
      fontSize: "12px",
      position: "right",
      offsetX: 0,
      offsetY: 10,
      labels: {
        useSeriesColors: false,
      },
      formatter: function (seriesName, opts) {
        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
      },
      itemMargin: {
        horizontal: 3,
      },
    },
    title: {
      text: "text de ejemplo",
    },
    xaxis: {
      categories: [],
    },
  };

  ngOnInit() {
    this.registerRadarForm = this.formBuilder.group({
      column: [null, [Validators.required]],
      date: [null, [Validators.required]],
      value: [null, [Validators.required]],
      color: ['transparent', [Validators.required]],
      position: [{ name: "bottom", title: "Abajo" }, [Validators.required]],
      title: ["Titulo de ejemplo", [Validators.required]],
      estilo: [
        { name: "Basic Radar", title: "Basic Radar" },
        [Validators.required],
      ],
    });
    this.controls = this.registerRadarForm.controls;
  }

  showGraphic() {
    this.submitted = true;
    this.spinner.show()

    if (this.registerRadarForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
      return;
    }

    switch (this.registerRadarForm.controls.estilo.value.name) {
      case "Basic Radar":
        this.objectFinal = {
          ...this.newObject,
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Multiple Series Radar":
        this.objectFinal = {
          ...this.newObject,
          chart: {
            height: 700,
            width: 700,
            type: "radar",
            dropShadow: {
              enabled: true,
              blur: 1,
              left: 1,
              top: 1,
            },
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true,
                customIcons: [],
              },
              export: {
                csv: {
                  filename: undefined,
                  columnDelimiter: ",",
                  headerCategory: "category",
                  headerValue: "value",
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString();
                  },
                },
                svg: {
                  filename: undefined,
                },
                png: {
                  filename: undefined,
                },
              },
              autoSelected: "zoom",
            },
          },
          stroke: {
            width: 0,
          },
          fill: {
            opacity: 0.5,
          },
          markers: {
            size: 0,
          },
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Polygon Fill":
        this.objectFinal = {
          ...this.newObject,
          dataLabels: {
            enabled: true,
          },
          plotOptions: {
            radar: {
              size: 140,
              polygons: {
                strokeColor: "#e9e9e9",
                fill: {
                  colors: ["#f8f8f8", "#fff"],
                },
              },
            },
          },
          markers: {
            size: 2,
            colors: ["#fff"],
            strokeColors: ["#FF4560"],
            strokeWidth: 2,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
          yaxis: {
            tickAmount: 7,
            labels: {
              formatter: function (val, i) {
                if (i % 2 === 0) {
                  return val;
                } else {
                  return "";
                }
              },
            },
          },
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;

      default:
        break;
    }

    this.objectFinal.legend.position =
      this.registerRadarForm.controls.position.value.name;
    this.objectFinal.chart.background =
      this.registerRadarForm.controls.color.value;
    this.objectFinal.title.text = this.registerRadarForm.controls.title.value;
    this.objectFinal.chart.toolbar.export.png.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal.chart.toolbar.export.svg.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal.chart.toolbar.export.csv.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");

    console.log("ad", this.objectFinal);

    //Peticion del grafico
    
    this.radarService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe((res: any) => {
        this.objectGraphic = this.getDataGrafic(res);
        this.datoFormater = this.getDateSeries(res);
        console.log("pipo martinez", this.objectGraphic);
        console.log("pipo martinez2", this.datoFormater);
        this.objectFinal.series = this.objectGraphic;
        this.objectFinal.series = this.objectFinal.series;
        this.objectFinal.xaxis.categories = this.datoFormater;
        this.objectFinal.xaxis.categories = this.objectFinal.xaxis.categories;
        this.onVewGraphic.emit(this.objectFinal);
      }, err => {
        this.toastr.error('Error consulta de datos del grafico Radar: ' +  err);
        this.spinner.hide();
        console.log('Error consulta de dtos del grafico Radar: ', err);
      });
      this.spinner.hide();
  }

  getDataGrafic(restultGrid) {
    let datos = restultGrid.data;
    let objectResult;
    let resultl = [];
    let prueba = [];
    let object = [];
    let posible = [];
    let seriesUnicas = [];
    let catergoriasUnicas = [];
    let nombreSeries = [];
    let formato;
    let array = [];
    let funcion;

    datos.forEach((element) => {
      for (const rey in element) {
        nombreSeries.push(rey);
      }
      let series = element[this.registerRadarForm.controls.column.value.field];
      seriesUnicas.push(series);
      let categories =
        element[this.registerRadarForm.controls.date.value.field];
      catergoriasUnicas.push(categories);
    });
    const valorSeriesUnicas = seriesUnicas.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);
    const valorcatergoriasUnicas = catergoriasUnicas.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    const valornombreSeries = nombreSeries.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    console.log("nombreSeries", valornombreSeries);
    console.log("series unicas", valorSeriesUnicas);
    console.log("categorias unicas", valorcatergoriasUnicas);
    valorSeriesUnicas.forEach((series) => {
      console.log("ejemplo", series);

      const result = datos.filter(
        (data) =>
          data[this.registerRadarForm.controls.column.value.field] === series
      );

      console.log(result);
      funcion = this.datosTratar(result, series);
    });

    console.log("funcion", funcion);
    return funcion || [];
  }

  datosTratar(visaul, series) {
    let formato = {};
    let data = [];
    visaul.forEach((element) => {
      if (
        element[this.registerRadarForm.controls.value.value.field] === null ||
        undefined
      ) {
        data.push(0);
      }
      data.push(element[this.registerRadarForm.controls.value.value.field]);
    });
    console.log(data);

    formato = {
      name: series,
      data: data,
    };
    this.objectoFinal.push(formato);

    return this.objectoFinal;
  }
  getDateSeries(date) {
     this.objectoFinal = [];
    let moreDate = date.data;
    let result = [];
    let objectResult: any = [];
    moreDate.forEach((element) => {
      console.log(element);
      result = element[this.registerRadarForm.controls.date.value.field];

      objectResult.push(result);
    });

    const asd = objectResult.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    console.log(asd);
    return asd;
  }
}
